'use client'

import { ArrowLeft24 } from '@vinted/monochrome-icons'
import { Button, Cell, Dialog, Navigation, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { ScrollableArea } from '@marketplace-web/common-components/scrollable-area-ui'

type Props = {
  show: boolean
  onBack: () => void
}

const ClosetPromotionDynamicPricingInfoModal = ({ show, onBack }: Props) => {
  const translate = useTranslate('closet_promotion.dynamic_pricing_info_modal')
  const a11yTranslate = useTranslate('closet_promotion.a11y.actions')
  const closetPromotionRenameAbTest = useAbTest('closet_promotion_rename')
  const isClosetPromotionRenameAbTestOn =
    closetPromotionRenameAbTest?.variant === 'a' || closetPromotionRenameAbTest?.variant === 'b'

  return (
    <Dialog show={show} hasScrollableContent>
      <div className="u-fill-width">
        <ScrollableArea>
          <Navigation
            left={
              <Button
                theme="amplified"
                iconName={ArrowLeft24}
                styling={Button.Styling.Flat}
                testId="closet-promotion-dynamic-pricing-info-back-button"
                onClick={onBack}
                aria={{ 'aria-label': a11yTranslate('back') }}
              />
            }
            body={
              <Text
                as="h2"
                text={isClosetPromotionRenameAbTestOn ? translate('title_v2') : translate('title')}
                type={Text.Type.Title}
              />
            }
          />
          <Cell
            title={<Text as="h3" text={translate('what.title')} type={Text.Type.Title} />}
            body={
              <Text
                as="span"
                text={
                  isClosetPromotionRenameAbTestOn
                    ? translate('what.body_v2')
                    : translate('what.body')
                }
                html
              />
            }
          />
          <Cell
            title={
              <Text
                as="h3"
                text={
                  isClosetPromotionRenameAbTestOn
                    ? translate('how.title_v2')
                    : translate('how.title')
                }
                type={Text.Type.Title}
              />
            }
            body={
              <Text
                as="span"
                text={
                  isClosetPromotionRenameAbTestOn ? translate('how.body_v2') : translate('how.body')
                }
                html
              />
            }
          />
        </ScrollableArea>
      </div>
    </Dialog>
  )
}

export default ClosetPromotionDynamicPricingInfoModal
